import { FC } from 'react';
import { Outlet, useOutletContext } from 'react-router';

import { CommonOutletContext } from '@app/app/layouts';
import { Header } from '@app/widgets/header';

export const DefaultLayout: FC = () => {
  const context = useOutletContext<CommonOutletContext>();

  return (
    <div className="relative">
      <Header />
      <main className="min-h-[calc(100vh-6rem)]">
        <Outlet context={context} />
      </main>
    </div>
  );
};
